import { gql } from '@apollo/client'

export const AUTHENTICATE_USER_WITH_LOGIN_CODE = gql`
  mutation authenticateUserWithLoginCode($input: AuthenticateUserWithLoginCodeInput!) {
    authenticateUserWithLoginCode(input: $input) {
      apiAccessToken {
        tokenString
      }
      errors {
        code
        message
      }
    }
  }
`
